import { ApiKeyCredentials } from '@azure/ms-rest-js'
import { PredictionAPIClient } from '@azure/cognitiveservices-customvision-prediction'
import {endPoint, predictionKey, projectId, publishIterationName} from "../custom-vision-config";

const camera = function () {
    let width = 0;
    let height = 0;

    const createObjects = function () {
        const cameraContainer = document.createElement('div')
        cameraContainer.classList.add('camera-container')
        const video = document.createElement('video');
        video.id = 'video';
        video.width = width;
        video.heigth = height;
        video.autoplay = true;
        cameraContainer.appendChild(video);
        document.body.appendChild(cameraContainer)

        const canvas = document.createElement('canvas');
        canvas.id = 'canvas';
        canvas.width = width;
        canvas.height = height;
        document.body.appendChild(canvas);
    }


    return {
        video: null,
        context: null,
        canvas: null,

        startCamera: function (w = 680, h = 480) {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                width = w;
                height = h;

                createObjects();

                this.video = document.getElementById('video');
                this.canvas = document.getElementById('canvas');
                this.context = this.canvas.getContext('2d');

                (function (video) {
                    navigator.mediaDevices.getUserMedia({video: true}).then(function (stream) {
                        video.srcObject = stream;
                        video.play();
                    });
                })(this.video)

            }
        },


        takeSnapshot: async function (param1, callback) {
            
            this.context.drawImage(this.video, 0, 0, width, height);

            this.canvas.toBlob(async blob => {
                const predictorCredentials = new ApiKeyCredentials({ inHeader: { "Prediction-key": predictionKey } });
                const predictor = new PredictionAPIClient(predictorCredentials, endPoint);

                const res = await predictor.classifyImage(projectId, publishIterationName, blob)
                res.predictions.forEach(predictedResult => {
                    console.log(`${predictedResult.tagName}: ${predictedResult.probability}`)
                })

                const maxProbTag = res.predictions.reduce((predictA, predictB) => {
                    return predictA.probability > predictB.probability ? predictA : predictB
                }).tagName

                console.log(maxProbTag);
                callback(maxProbTag);
            })

        }
    }
    }();

export default camera;
